import React from 'react';
import { Patient } from '@/types/Patient';
import { Procedure } from '@/types/Procedure';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import NextProcedures from '@/components/pages/kiosk/tablet/v2/NextProcedures';
import TimeOut2ActionButton from '@/components/pages/kiosk/tablet/v2/TimeOut2ActionButton';
import CurrentTime from '@/components/pages/kiosk/charting/components/CurrentTime';
import { useStyles } from '../ProcedureHandling';

type ProcedureFooterSectionProps = {
  roomName: string;
  isPreviousPatient: boolean;
  nextProceduresInOperationRoom: Procedure[];
  status: string;
  patient?: Patient & { duration?: string };
};

export const ProcedureFooterSection = ({
  roomName,
  isPreviousPatient,
  nextProceduresInOperationRoom,
  status,
  patient,
}: ProcedureFooterSectionProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.footer}>
      <Box style={{ flex: 1 }}>
        <Typography>{roomName}</Typography>
      </Box>
      {!isPreviousPatient && (
        <Box className={classes.footerActions}>
          <NextProcedures nextProceduresInOperationRoom={nextProceduresInOperationRoom} />
          <TimeOut2ActionButton patient={patient} status={status} />
        </Box>
      )}
      <Box style={{ flex: 1, textAlign: 'right' }}>
        <Typography variant="h2" style={{ fontWeight: 'bold' }}>
          <CurrentTime />
        </Typography>
      </Box>
    </Box>
  );
};
